import styled from "styled-components";

export * from "../SubmitARequestPage/SubmitARequestPage.styles";

export const AlternativeContact = styled.p`
  color: rgba(255, 255, 255, 0.5);
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.21px;
  line-height: 150%;
  margin: -4px 0 0;
  text-align: center;

  a {
    color: #fff;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;
